import { IconButton } from '@mui/material';
import { CaretLeft, CaretRight } from '@phosphor-icons/react';
import { useRef, useState, useEffect } from 'react';
import { scrollTo } from 'seamless-scroll-polyfill';

interface ScrollableRowProps {
  children: React.ReactNode;
}

const ScrollableRow = ({ children }: ScrollableRowProps) => {
  const scrollContainerRef = useRef<HTMLDivElement>(null);
  const [isAtStart, setIsAtStart] = useState(true);
  const [isAtEnd, setIsAtEnd] = useState(false);

  useEffect(() => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsAtEnd(
        container.scrollWidth - container.offsetWidth <= container.scrollLeft,
      );
    }
  }, [children]);

  const checkScrollPosition = () => {
    const container = scrollContainerRef.current;
    if (container) {
      setIsAtStart(container.scrollLeft === 0);
      setIsAtEnd(
        container.scrollWidth - container.offsetWidth <= container.scrollLeft,
      );
    }
  };

  const scrollLeft = () => {
    if (!scrollContainerRef.current) return;

    scrollTo(scrollContainerRef.current, {
      left:
        scrollContainerRef.current.scrollLeft -
        scrollContainerRef.current.offsetWidth,
      behavior: 'smooth',
    });
  };

  const scrollRight = () => {
    if (!scrollContainerRef.current) return;

    scrollTo(scrollContainerRef.current, {
      left:
        scrollContainerRef.current.scrollLeft +
        scrollContainerRef.current.offsetWidth,
      behavior: 'smooth',
    });
  };

  return (
    <div className='flex items-center gap-4 w-full'>
      {!isAtStart && (
        <IconButton onClick={scrollLeft}>
          <CaretLeft />
        </IconButton>
      )}
      <div
        className='flex flex-row gap-2 flex-grow overflow-x-auto scrollbar-none w-[800px] whitespace-nowrap'
        ref={scrollContainerRef}
        onScroll={checkScrollPosition}
      >
        {children}
      </div>
      {!isAtEnd && (
        <IconButton onClick={scrollRight}>
          <CaretRight />
        </IconButton>
      )}
    </div>
  );
};

export default ScrollableRow;
